import { LayoutColumn } from './LayoutColumn';
import { CommonLayoutProps } from './LayoutComponent';

interface ComponentProps extends CommonLayoutProps {
  data: LayoutNode;
  fieldFragmentsMap: Map<string, FieldInfo>;
}

export const LayoutGroup = ({ data, fieldFragmentsMap, ...rest }: ComponentProps) => {
  return (
    <div className="p-6 bg-white w-full rounded-lg">
      {data.name && (<h2>{data.name}</h2>)}
      <div className="flex gap-x-8">
        {data.children.map((column) => (
          <LayoutColumn key={column.id} data={column} fieldFragmentsMap={fieldFragmentsMap} {...rest} />
        ))}
      </div>
    </div>
  );
};
